import script from "./GlobalGroupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalGroupModal.vue?vue&type=script&setup=true&lang=js"

import "./GlobalGroupModal.vue?vue&type=style&index=0&id=b5d7cc74&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5d7cc74"]])

export default __exports__